import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const TableHeartIcon = createSvgIcon(
  <>
    <path
      d="M11.5 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V11"
      {...strokeProps}
    />
    <path d="M3 10H21" {...strokeProps} />
    <path d="M10 3V21" {...strokeProps} />
    <path
      d="M18.0001 22L21.3501 18.716C21.5556 18.5166 21.719 18.2782 21.8307 18.0146C21.9425 17.7511 22.0003 17.4678 22.0007 17.1815C22.0012 16.8953 21.9443 16.6118 21.8334 16.3479C21.7225 16.084 21.5599 15.845 21.3551 15.645C20.9373 15.2363 20.3763 15.007 19.7918 15.0059C19.2074 15.0048 18.6455 15.2319 18.2261 15.639L18.0021 15.859L17.7791 15.639C17.3613 15.2306 16.8006 15.0015 16.2163 15.0004C15.6321 14.9992 15.0705 15.2262 14.6511 15.633C14.4456 15.8323 14.2821 16.0707 14.1703 16.3342C14.0585 16.5977 14.0006 16.881 14 17.1672C13.9994 17.4535 14.0562 17.7369 14.167 18.0009C14.2778 18.2648 14.4404 18.5039 14.6451 18.704L18.0001 22Z"
      {...strokeProps}
    />
  </>,
  { displayName: 'TableHeartIcon', viewBox: '0 0 24 24' }
);
